import { render, staticRenderFns } from "./classificationIAModal.vue?vue&type=template&id=88c02492&scoped=true&"
import script from "./classificationIAModal.vue?vue&type=script&lang=js&"
export * from "./classificationIAModal.vue?vue&type=script&lang=js&"
import style0 from "./classificationIAModal.vue?vue&type=style&index=0&id=88c02492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c02492",
  null
  
)

export default component.exports